import { type AnchorHTMLAttributes, type ButtonHTMLAttributes, type FC } from "react";

import classNames from "classnames";

import { type DirectionalIconComponent } from "@jti/brand-icons";
import { LinkBehaviour } from "@jti/core-components/components/LinkBehaviour";

import styles from "./RoundButton.module.scss";

export type RoundButtonProps = {
  icon: DirectionalIconComponent;
  withBorder?: boolean;
  disabled?: boolean;
  "aria-label": string;
} & (AnchorHTMLAttributes<HTMLAnchorElement> | ButtonHTMLAttributes<HTMLButtonElement>);

export const RoundButton: FC<RoundButtonProps> = ({ icon: Icon, withBorder = false, className, disabled, ...rest }) => {
  if ("href" in rest) {
    return (
      <LinkBehaviour
        {...rest}
        className={classNames(styles.roundButton, className, {
          [styles.withBorder]: withBorder,
          [styles.disabled]: disabled,
        })}
      >
        <Icon className={classNames(styles.icon)} aria-hidden="true" />
      </LinkBehaviour>
    );
  }
  return (
    <button
      className={classNames(styles.roundButton, {
        [styles.withBorder]: withBorder,
      })}
      type="button"
      disabled={disabled}
      {...(rest as ButtonHTMLAttributes<HTMLButtonElement>)}
    >
      <Icon className={classNames(styles.icon)} aria-hidden="true" />
    </button>
  );
};
